import '@talentmesh/table/styles.css';
import React from 'react';
import { TypographyH2 } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import TeamMemberTabContent from './TeamMemberTabContent';
import { TeamMembersContext } from './Context/TeamMembersContext';
import useTeamMembersContextValue from './Context/useTeamMembersContextValue';

const TeamMembersTab = () => {
    const value = useTeamMembersContextValue();

    return (
        <TeamMembersContext.Provider value={value}>
            <div className="flex flex-col gap-6">
                <TypographyH2>{UIStrings.TeamMembers}</TypographyH2>
                <TeamMemberTabContent />
            </div>
        </TeamMembersContext.Provider>
    );
};

export default TeamMembersTab;
